export const customproductbuilder = () => {
  document.addEventListener('DOMContentLoaded', () => {
    let cbpItems = document.querySelectorAll('[data-cpb-request-url]');
    if (cbpItems && cbpItems.length) {
      cbpItems.forEach(function (el) {
        var requestUrl = el.getAttribute('data-cpb-request-url');
        if (requestUrl === '') return;

        var cpbCdnRequest = new XMLHttpRequest();
        cpbCdnRequest.open('GET', requestUrl, true);
        cpbCdnRequest.onload = function () {
          if (cpbCdnRequest.status >= 200 && cpbCdnRequest.status < 400) {
            var data = JSON.parse(cpbCdnRequest.responseText);
            var tpl = '';
            var propsObj = data.cartData[0].properties;
            for (var key in propsObj) {
              if (
                key == 'SKU' ||
                key.startsWith('_', 0) ||
                key.startsWith('View', 0)
              ) {
                continue;
              }
              tpl += '<li>' + key + ': ' + propsObj[key] + '</li>';
            }
            tpl +=
              '<li class="cpbProductAlert">注文キャンセルまたは内容変更の場合は、必ずご注文後3日以内に弊社カスタマーサポートまでご連絡くださいませ。<br>キャンセルフォームからの申請はご利用いただけません。</li>';
            el.innerHTML = tpl;
          } else {
            console.error(
              'Request failed: ' +
                cpbCdnRequest.statusText +
                ". Can't get custom product properties"
            );
          }
        };
        cpbCdnRequest.onerror = function () {
          console.error("Request failed: Can't get custom product properties");
        };
        cpbCdnRequest.send();
      });
    }
  });
};
